import { Button } from "antd";
import { FormattedMessage } from "react-intl";
import Popup from "../Popup/Popup";
import { Props } from "./UploadImage.model";
import { useUploadImage } from "./useUploadImage";
import styles from './UploadImage.module.scss';
import Icon from "../Icon/Icon";

const UploadImage = ({ onClose, currentUser, afterClosed }: Props) => {
  const { onClosePopup, onDeleteImage, onSaveUploadedImage, onSelectImage, state } = useUploadImage({
    afterClosed,
    currentUser,
    onClose
  });
  const { selectedImage } = state;
  

  const renderImagePopup = () => {
    return <Popup
      onClose={onClosePopup}
      title={{ action: 'edit', target: 'profilePhoto' }}>
      <>
        <div className={styles.popupContent}>
          <div className={styles.imageWrapper}>
            {(selectedImage.url || currentUser?.imageId) && <img alt="Profile" src={selectedImage.url ? selectedImage.url : currentUser?.imageId} />}
            {(!selectedImage.url && !currentUser?.imageId) && <Icon name="image" height="60px" width="60px" color="white" />}
          </div>
        </div>
        <div className={styles.popupActions}>

          <Button className={`${styles.delete} ${styles.redButtonLink}`} type='link' size='large' onClick={onDeleteImage}>
            <Icon name='trash' color='red' />
            <FormattedMessage id='buttons.delete' />
          </Button>
          <div>
            <Button className={styles.edit} type='default' size='large'>
              <input className={styles.hiddenFileInput} type='file' onChange={onSelectImage} accept="image/*"/>
              <FormattedMessage id={currentUser?.imageId ? 'buttons.replacePhoto' : 'buttons.uploadPhoto'} />
            </Button>
            {selectedImage.file &&
              <Button className={styles.save} onClick={onSaveUploadedImage} size="large" type="primary">
                <FormattedMessage id='buttons.save' />
              </Button>}
          </div>
        </div>
      </>
    </Popup>
  }
  return renderImagePopup();
}

export default UploadImage;